const normalizePathname = (pathname = '/') => {
  const clean = String(pathname || '/').split('?')[0].split('#')[0] || '/';
  return clean.startsWith('/') ? clean : `/${clean}`;
};

const matchesPrefix = (pathname, prefix) => {
  const cleanPath = normalizePathname(pathname);
  const cleanPrefix = normalizePathname(prefix).replace(/\/+$/, '') || '/';
  if (cleanPrefix === '/') return cleanPath === '/';
  return cleanPath === cleanPrefix || cleanPath.startsWith(`${cleanPrefix}/`);
};

export const JG_RADIO_DOCK_ALLOWLIST_PREFIXES = Object.freeze([]);

export const JG_RADIO_DOCK_ALLOWLIST_EXACT_PATHS = Object.freeze([]);

export const JG_RADIO_DOCK_DENYLIST_PREFIXES = Object.freeze([
  '/login',
  '/register',
  '/reset',
  '/hitlab',
  '/docs',
  '/_ui',
]);

export const getJGRadioDockRouteDecision = ({
  pathname = '/',
  isAuthenticated = false,
} = {}) => {
  const cleanPathname = normalizePathname(pathname);
  const deniedBy = JG_RADIO_DOCK_DENYLIST_PREFIXES.find((prefix) =>
    matchesPrefix(cleanPathname, prefix),
  );
  if (deniedBy) {
    return {
      show: false,
      reason: 'hard_hidden_route',
      matchedRoute: deniedBy,
      pathname: cleanPathname,
    };
  }

  if (!isAuthenticated) {
    return {
      show: false,
      reason: 'authentication_required',
      matchedRoute: '',
      pathname: cleanPathname,
    };
  }

  return {
    show: true,
    reason: 'authenticated_sitewide',
    matchedRoute: '',
    pathname: cleanPathname,
  };
};

export const shouldShowJGRadioDock = (args = {}) =>
  getJGRadioDockRouteDecision(args).show;
